"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var prefixes = [
    {
        countryCode: 'IT',
        label: 'Italia (+39)',
        value: '+39',
    },
    {
        countryCode: 'ES',
        label: 'España (+34)',
        value: '+34',
    },
    {
        countryCode: 'GB',
        label: 'United Kingdom (+44)',
        value: '+44',
    },
    {
        countryCode: 'US',
        label: 'United States (+1)',
        value: '+1',
    },
    {
        countryCode: 'AT',
        label: 'Austria (+43)',
        value: '+43',
    },
    {
        countryCode: 'BE',
        label: 'Belgium (+32)',
        value: '+32',
    },
    {
        countryCode: 'BG',
        label: 'Bulgaria (+359)',
        value: '+359',
    },
    {
        countryCode: 'CY',
        label: 'Cyprus (+357)',
        value: '+357',
    },
    {
        countryCode: 'CZ',
        label: 'Czech Republic (+420)',
        value: '+420',
    },
    {
        countryCode: 'DE',
        label: 'Germany (+49)',
        value: '+49',
    },
    {
        countryCode: 'DK',
        label: 'Denmark (+45)',
        value: '+45',
    },
    {
        countryCode: 'EE',
        label: 'Estonia (+372)',
        value: '+372',
    },
    {
        countryCode: 'FI',
        label: 'Finland (+358)',
        value: '+358',
    },
    {
        countryCode: 'FR',
        label: 'France (+33)',
        value: '+33',
    },
    {
        countryCode: 'GR',
        label: 'Greece (+30)',
        value: '+30',
    },
    {
        countryCode: 'HU',
        label: 'Hungary (+36)',
        value: '+36',
    },
    {
        countryCode: 'IE',
        label: 'Ireland (+353)',
        value: '+353',
    },
    {
        countryCode: 'LT',
        label: 'Lithuania (+370)',
        value: '+370',
    },
    {
        countryCode: 'LU',
        label: 'Luxembourg (+352)',
        value: '+352',
    },
    {
        countryCode: 'MT',
        label: 'Malta (+356)',
        value: '+356',
    },
    {
        countryCode: 'MX',
        label: 'Mexico (+52)',
        value: '+52',
    },
    {
        countryCode: 'NL',
        label: 'Netherlands (+31)',
        value: '+31',
    },
    {
        countryCode: 'PL',
        label: 'Poland (+48)',
        value: '+48',
    },
    {
        countryCode: 'PT',
        label: 'Portugal (+351)',
        value: '+351',
    },
    {
        countryCode: 'RO',
        label: 'Romania (+40)',
        value: '+40',
    },
    {
        countryCode: 'SE',
        label: 'Sweden (+46)',
        value: '+46',
    },
    {
        countryCode: 'SI',
        label: 'Slovenia (+386)',
        value: '+386',
    },
    {
        countryCode: 'SK',
        label: 'Slovakia (+421)',
        value: '+421',
    },
];
exports.default = prefixes;
//# sourceMappingURL=data:application/json;base64,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